import { Injectable } from '@angular/core';
import { Adapter } from '../../../../interfaces/Adapter';
import { HourlyRequiredEmployeePrediction, } from '../../../models/prediction/HourlyRequiredEmployeePrediction';
import { DailyRequiredEmployeePrediction } from '../../../models/prediction/DailyRequiredEmployeePrediction';
import {
  RequiredEmployeesHourlyPredictionResponse,
  RequiredEmployeesPredictionResponse
} from '../../../../interfaces/response/PredictionsResponses';

/**
 * An adapter converts daily required employee prediction HTTP response to domain object.
 */
@Injectable({
  providedIn: 'root'
})
export class RequiredEmployeePredictionAdapter implements Adapter<DailyRequiredEmployeePrediction> {

  /**
   * Converts daily required employee prediction HTTP response to {@link DailyRequiredEmployeePrediction}.
   * @param item daily required employee prediction HTTP response.
   */
  adapt(item: RequiredEmployeesPredictionResponse): DailyRequiredEmployeePrediction {
    const adapter = new RequiredEmployeeHourlyPredictionAdapter();

    return new DailyRequiredEmployeePrediction(
      item.date,
      item.hourlyPredictions
        .map(hourlyPrediction => adapter.adapt(hourlyPrediction))
        .sort((first, second) => first.hour > second.hour ? 1 : -1)
    );
  }
}

/**
 * An adapter converts hourly required employee prediction HTTP response to domain object.
 */
@Injectable({
  providedIn: 'root'
})
export class RequiredEmployeeHourlyPredictionAdapter implements Adapter<HourlyRequiredEmployeePrediction> {

  /**
   * Converts hourly required employee prediction HTTP response to {@link HourlyRequiredEmployeePrediction}.
   * @param item hourly required employee prediction HTTP response.
   */
  adapt(item: RequiredEmployeesHourlyPredictionResponse): HourlyRequiredEmployeePrediction {
    return new HourlyRequiredEmployeePrediction(
      item.hour,
      item.prediction
    );
  }
}
